import {useState, useEffect} from 'react'
import {formatMaintenanceWindow} from '../../utils/maintenanceWindow'
import InfoIcon from '../../images/svg/InfoIcon'

interface MaintenanceBannerProps {
  title?: string
  message?: string
  startDate: Date | null
  endDate: Date | null
}

export default function MaintenanceBanner({
  title = 'Maintenance Mode',
  message = 'The Kegstar Collections application will be unavailable during the following maintenance window:',
  startDate = null,
  endDate = null,
}: MaintenanceBannerProps) {
  const [maintenanceWindow, setMaintenanceWindow] = useState<{
    date: string
    startTime: string
    endTime: string
    timeZone?: string
  } | null>(null)

  useEffect(() => {
    if (!startDate || !endDate) return

    setMaintenanceWindow(formatMaintenanceWindow(startDate, endDate))
  }, [startDate, endDate])

  return (
    <div className="p-4">
      <div
        className={[
          'bg-amber-50 dark:bg-amber-900/60',
          'shadow shadow-amber-300 dark:shadow-amber-900/60',
          'p-4 rounded-lg',
        ].join(' ')}
      >
        <div className="flex items-center gap-2 mb-2">
          <div>
            <InfoIcon className="w-6 h-6 text-amber-700 dark:text-amber-300" />
          </div>
          <h1 className="text-lg font-medium text-amber-800 dark:text-amber-200">{title}</h1>
        </div>
        <p className="text-sm text-amber-700 dark:text-amber-300">
          {message} {''}
        </p>
        {maintenanceWindow ? (
          <p className="text-sm text-amber-600 dark:text-amber-400 mt-2">
            <strong>{maintenanceWindow.date}</strong> from{' '}
            <strong>
              {maintenanceWindow.startTime} to {maintenanceWindow.endTime}
            </strong>
            .
          </p>
        ) : null}

        {maintenanceWindow?.timeZone && (
          <p className="mt-1 text-xs text-amber-700 dark:text-amber-300">
            Times shown in your device time zone: {maintenanceWindow.timeZone}
          </p>
        )}
      </div>
    </div>
  )
}
